export const publicVersion = "2.3.0-36-g8719e15f";